// extracted by mini-css-extract-plugin
export default {"row":"center_row__vrizf","fullScreen":"center_fullScreen__TcBbB","column":"center_column__DqgcY"};